import React from 'react';
import {Box} from '@mui/material';
import {TEXTE_SECONDAIRE} from '../../tokens.js';

// Petit tableau d'une carte d'analyse. `colonnes` : [{cle, libelle, droite?}] ; `lignes` : objets déjà formatés (chaînes).
export default function PetitTableau({colonnes, lignes, legende}) {
    return (
        <Box component="table" aria-label={legende} sx={{width: '100%', borderCollapse: 'collapse', fontSize: 12}}>
            <thead>
                <tr>
                    {colonnes.map((c) => (
                        <Box key={c.cle} component="th" scope="col" sx={{textAlign: c.droite ? 'right' : 'left', py: '4px', pr: '8px', fontWeight: 600, color: TEXTE_SECONDAIRE, borderBottom: '1px solid #EEF1F4', whiteSpace: 'nowrap'}}>{c.libelle}</Box>
                    ))}
                </tr>
            </thead>
            <tbody>
                {lignes.map((l, i) => (
                    <tr key={l.cle ?? i}>
                        {colonnes.map((c) => (
                            <Box key={c.cle} component="td" sx={{textAlign: c.droite ? 'right' : 'left', py: '4px', pr: '8px', borderBottom: '1px solid #F3F5F7', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap'}}>{l[c.cle]}</Box>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Box>
    );
}
